import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const invitesApi = createApi({
  reducerPath: 'invitesQueries',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Invites'],
  endpoints: (builder) => ({
    // Promote user to INVITED role (admin only)
    promoteToInvited: builder.mutation({
      query: (userId) => ({
        url: 'invites/promote',
        method: 'POST',
        body: { userId },
      }),
      invalidatesTags: ['Invites'],
    }),

    // Get all users with INVITED role (admin only)
    getInvitedUsers: builder.query({
      query: () => 'invites',
      providesTags: ['Invites'],
    }),

    // Revoke invited status (admin only)
    revokeInvitedStatus: builder.mutation({
      query: (userId) => ({
        url: `invites/${userId}/revoke`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Invites'],
    }),
  }),
});

export const { usePromoteToInvitedMutation, useGetInvitedUsersQuery, useRevokeInvitedStatusMutation } = invitesApi;
